/**
 * Hệ thống tùy chỉnh ngầm định nghiệp vụ
 */
export default {
    
		/// Không chọn
		None: 0,

		/// Tạm ứng đã cấp dự toán
		AdvanceDistributed: 2,

		/// Tạm ứng chưa cấp dự toán
		AdvanceUndistributed: 3,

		/// Thanh toán tạm ứng
		AdvancePayment: 4,

		/// Thực chi
		Expense: 6,

		/// Nhận dự toán
		PlanReceipt: 7,

		/// Nhận lệnh chi tạm ứng
		TreasuryWarrantReceipt: 8,

		/// Ghi thu, ghi chi
		ReceiptExpense: 9,

		/// Nhận lệnh chi thực chi
		TreasuryWarrantReceiptExpense: 10,

		/// Giảm chi - Thực chi.
		ExpenseReduce: 12,

		/// Giảm chi - Tạm ứng.
		ExpenseReduceAdvance: 13,

		/// Nộp trả - Thực chi
		RefundExpense: 15,

		/// Nộp trả - Tạm ứng
		RefundAdvance: 16,

		/// Bổ sung
		Supplement: 24,

		/// Khôi phục - Thực chi
		RestoreExpense: 30,

		/// Khôi phục - Tạm ứng
		RestoreAdvance: 31,

		/// Xuất toán
		BudgetRejecttion: 33,

		/// Giảm thu
		ReceiptBudgetReturn: 36,

		/// Điều chỉnh tăng thuế GTGT
		IncrementAdjustment: 39,

		/// Điều chỉnh giảm thuế GTGT
		DecrementAdjustment: 42,

		/// Hủy dự toán
		DestroyPlanning: 45,

		/// ntda 16/12/2015 Điều chỉnh dự toán
		BUPlanAdjustment: 46,

		/// HỦy lệnh chi tiền
		DestroyReceipt: 50,

		/// Lệnh chi cấp cho cấp dưới (dùng cho đặc thù VPTW Đảng)
		ReceiptForInferior: 60,

		/// Lệnh chi nhận từ cấp trên (dùng cho đặc thù VPTW Đảng)
		ReceivedReceiptFromSuperiors: 61
}